import { render, staticRenderFns } from "./PosDobPicker.vue?vue&type=template&id=59248204&"
import script from "./PosDobPicker.vue?vue&type=script&lang=js&"
export * from "./PosDobPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports